
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 .875a7.125 7.125 0 110 14.25A7.125 7.125 0 018 .875zm-.375 10.5H5.707c.39.792.916 1.587 1.581 2.385.02.024.037.05.05.078.094.01.19.02.287.025v-2.488zm2.668 0H8.375v2.488c.097-.006.193-.014.289-.025a.308.308 0 01.048-.078c.665-.798 1.192-1.593 1.581-2.385zm-5.414 0H3.19a5.888 5.888 0 003.01 2.22 11.798 11.798 0 01-1.322-2.22zm7.93 0h-1.688a11.771 11.771 0 01-1.323 2.22 5.886 5.886 0 003.011-2.22zm-8.675-3H2.137a5.84 5.84 0 00.606 2.25H4.58a8.038 8.038 0 01-.447-2.25zm3.491 0h-2.74a7.4 7.4 0 00.494 2.25h2.246v-2.25zm3.49 0h-2.74v2.25h2.246a7.4 7.4 0 00.494-2.25zm2.748 0h-1.997a8.038 8.038 0 01-.447 2.25h1.838a5.84 5.84 0 00.606-2.25zm-9.283-3H2.742a5.84 5.84 0 00-.605 2.25h1.997a8.037 8.037 0 01.446-2.25zm3.045 0H5.379a7.4 7.4 0 00-.494 2.25h2.74v-2.25zm2.996 0H8.375v2.25h2.74a7.4 7.4 0 00-.494-2.25zm2.637 0H11.42c.26.749.409 1.499.446 2.25h1.997a5.84 5.84 0 00-.605-2.25zm-7.056-2.97l-.099.033A5.89 5.89 0 003.19 4.625h1.688a11.77 11.77 0 011.324-2.22zm1.423-.268a5.908 5.908 0 00-.289.025.308.308 0 01-.048.078c-.665.798-1.192 1.593-1.581 2.386l1.918-.001zm.75 0v2.488h1.918a11.703 11.703 0 00-1.333-2.08l-.248-.305a.376.376 0 01-.05-.078 5.211 5.211 0 00-.286-.025zm1.423.268l.206.285a11.51 11.51 0 011.118 1.935h1.688a5.888 5.888 0 00-3.012-2.22z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    